import { useDispatch, useSelector } from 'react-redux';
import {
  inviteeChangedMetaDataSelector,
  isInviteeChangedPanelOpenSelector,
  setInviteeChangedMetaData,
  setIsInviteeChangedPanelOpen,
} from '../../../../../../../features/pageFeatures/createHearingPageSlice';

export const useInviteeChanged = () => {
  const dispatch = useDispatch();

  const isPopupOpen = useSelector(isInviteeChangedPanelOpenSelector);
  const metaData = useSelector(inviteeChangedMetaDataSelector);

  function setIsPopupOpen() {
    dispatch(setInviteeChangedMetaData({}));
    dispatch(setIsInviteeChangedPanelOpen(false));
  }

  function onConfirm() {
    dispatch(setInviteeChangedMetaData({}));
    dispatch(setIsInviteeChangedPanelOpen(false));
  }

  return {
    metaData,
    isPopupOpen,
    setIsPopupOpen,
    onConfirm,
  };
};
